export const validateObject = (obj) => {
    return Object.keys(obj).filter(k => k !== "invoice_number" && k !== "invoice_name").every(k => obj[k] !== null && obj[k] !== '');
};
  